export default __webpack_public_path__ + "static/media/1282.9c68b378.png";